module.exports = __webpack_public_path__ + "static/two-9bbdf6e8b07b71d28edac3374ba56119.svg";